import { useCallback, useState } from 'react';

import authRequest from '../../../../utils/fetch';
import type { AgentSettingsResponse, CodePlannerSetting } from '../types';
import { codePlannerSettingsKey, jiraProjectContainerType } from '../types';

import { getAgentSettingsUrl } from './types';

export const useGetCodePlannerSettingsController = () => {
	const [error, setError] = useState<string | null>(null);
	const [loading, setLoading] = useState<boolean>(false);
	const [codePlannerSettingsCache, setCodePlannerSettingsCache] = useState<Map<string, boolean>>(
		new Map(),
	);

	const getCodePlannerSettings = useCallback(async (containerIdList: string[]) => {
		setLoading(true);
		setError(null);

		const settingsRequestList = containerIdList.map((containerId) => ({
			containerType: jiraProjectContainerType,
			containerId,
			key: codePlannerSettingsKey,
		}));

		const settingsMap = new Map<string, CodePlannerSetting>();

		try {
			const response = await fetch(
				authRequest(getAgentSettingsUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						settings: settingsRequestList,
					}),
				}),
			);

			if (!response.ok) {
				throw new Error(`Error: ${response.statusText}`);
			}

			const data = (await response.json()) as AgentSettingsResponse;

			if (!data.success) {
				throw new Error('Failed to get agent settings');
			}

			data.settings.forEach((item: CodePlannerSetting) => {
				settingsMap.set(item.containerId, item);
			});
		} catch (e) {
			setError('An error has occurred');
		}

		setLoading(false);

		return settingsMap;
	}, []);

	return {
		getCodePlannerSettings,
		codePlannerSettingsCache,
		setCodePlannerSettingsCache,
		loading,
		error,
	};
};
